<template>
  <a-dropdown :trigger="['click']" placement="bottomRight">
    <div :class="$style.dropdown">
      <span class="text-uppercase d-flex align-items-center">
        <img
          style="border-radius: 25%"
          width="20"
          :src="`resources/images/flags/${
            language == 'en'
              ? 'united-states'
              : language == 'fr'
              ? 'france'
              : language == 'sw'
              ? 'kenya'
              : 'tunisia'
          }.svg`"
          alt="Flag"
        />
        <span :class="$style.languageText">{{
          getNativeLanguageName(language)
        }}</span>
      </span>
    </div>
    <a-menu slot="overlay" @click="selectLocale">
      <a-menu-item key="en-US">
        <img
          style="border-radius: 25%; margin-right: 5px"
          width="20"
          src="resources/images/flags/united-states.svg"
          alt="Arabic"
        />
        English
      </a-menu-item>
      <a-menu-item v-if="shouldShowLanguage('fr-FR')" key="fr-FR">
        <img
          style="border-radius: 25%; margin-right: 5px"
          width="20"
          src="resources/images/flags/france.svg"
          alt="Arabic"
        />
        Français
      </a-menu-item>
      <a-menu-item v-if="shouldShowLanguage('ar-AR')" key="ar-AR">
        <img
          style="border-radius: 30%; margin-right: 5px"
          width="20"
          src="resources/images/flags/tunisia.svg"
          alt="Arabic"
        />
        عربية
      </a-menu-item>
      <a-menu-item v-if="shouldShowLanguage('sw-KE')" key="sw-KE">
        <img
          style="border-radius: 25%; margin-right: 5px"
          width="20"
          src="resources/images/flags/kenya.svg"
          alt="Swahili"
        />
        Kiswahili
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["settings", "user"]),
    language() {
      return this.settings.locale.substr(0, 2);
    },
    countryCode() {
      const building = this.user?.building?.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0] || {};
      return building.countryCode;
    },
  },
  watch: {
    countryCode() {
      this.validateAndSwitchLocale();
    },
  },
  mounted() {
    this.validateAndSwitchLocale();
  },
  methods: {
    validateAndSwitchLocale() {
      // If current locale is no longer valid for the current country code, switch to English
      if (!this.shouldShowLanguage(this.settings.locale)) {
        this.$store.commit("settings/CHANGE_SETTING", {
          setting: "locale",
          value: "en-US",
        });
      }
    },
    selectLocale(item) {
      const setting = "locale";
      this.$store.commit("settings/CHANGE_SETTING", {
        setting,
        value: item.key,
      });
    },
    getNativeLanguageName(lang) {
      const languageNames = {
        en: "English",
        fr: "Français",
        ar: "عربية",
        sw: "Kiswahili",
      };
      return languageNames[lang] || "Français";
    },
    shouldShowLanguage(locale) {
      if (locale === "en-US") return true; // English always shown
      if (locale === "fr-FR" || locale === "ar-AR") {
        return this.countryCode === "TN";
      }
      if (locale === "sw-KE") {
        return this.countryCode === "KE";
      }
      return false;
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
